import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	typography: {
		fontFamily: '"Times New Roman", serif'
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				body: {
					fontFamily: '"Times New Roman", serif'
				}
			}
		},
		MuiLink: {
			defaultProps: {
				color: 'inherit',
				underline: 'always',
				// All MUI Link uses in this app are external (edcat.net, the
				// story's own website, etc.) — open them in a new tab and add
				// the security-conscious rel attributes by default.
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			styleOverrides: {
				root: {
					color: '#000',
					textDecorationColor: '#000'
				}
			}
		}
	}
});

export default theme;
